module.exports = __webpack_public_path__ + "img/effect.6343464e.svg";